import React from 'react';
import {
    ConsigneeCatalog,
    ConsigneeTerms,
    RealOwnerInfo,
    RepresentativeInfo,
    ShareholderInfo,
} from 'commons/types/Types';

export type EfeRelatedPeopleContextType = {
    percentageCompleted: number;
    shareholders: ShareholderInfo[];
    setPercentageCompleted: (percentageCompleted: number) => void;
    setShareholders: (data: ShareholderInfo[]) => void;
    tempRepresentative: RepresentativeInfo | undefined;
    setTempRepresentative: (data: RepresentativeInfo | undefined) => void;
    representatives: RepresentativeInfo[];
    setRepresentatives: (data: RepresentativeInfo[]) => void;
    selectedRepresentative: number;
    setSelectedRepresentative: (data: number) => void;
    tempShareholder: ShareholderInfo | undefined;
    setTempShareholder: (date: ShareholderInfo | undefined) => void;
    isTempShareholderActive: boolean;
    setTempShaholderActive: (data: boolean) => void;
    shareholdersSizeTemp: number;
    setShareholdersSizeTemp: (data: number) => void;
    realOwners: RealOwnerInfo[];
    setRealOwners: (data: RealOwnerInfo[]) => void;
    tempRealOwner: RealOwnerInfo | undefined;
    setTempRealOwner: (data: RealOwnerInfo | undefined) => void;
    isTempRealOwnerActive: boolean;
    setTempRealOwnerActive: (data: boolean) => void;
    editLocation: boolean;
    setEditLocation: (data: boolean) => void;
    shareholderPersonType: string;
    setShareholderPersonType: (data: string) => void;
    resetRelatedPeopleContext: () => void;
    consigneesConfig: ConsigneeTerms | undefined;
    setConsigneesConfig: (values: ConsigneeTerms) => void;
    loadUsers: Array<ConsigneeCatalog>;
    setLoadUsers: (values: Array<ConsigneeCatalog>) => void;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const OnbordingRelatedPeopleContext = React.createContext<EfeRelatedPeopleContextType>();

export function useRelatedPeopleContext() {
    return React.useContext(OnbordingRelatedPeopleContext);
}

export default OnbordingRelatedPeopleContext;
